<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryRef" :inline="true" v-show="showSearch">
      <el-form-item :label="$t('company.table.name')" prop="deptName">
        <el-input
            v-model="queryParams.deptName"
            :placeholder="'会社名' + $t('global.plsInput')"
            clearable
            style="width: 200px"
            v-ctrl-enter="handleQuery"
        />
      </el-form-item>
      <el-form-item :label="$t('global.status')" prop="status">
        <keep-result-select
            style="width: 200px"
            :placeholder="$t('global.deptStatus')"
            v-model="queryParams.status"
            :list="sys_normal_disable"
          />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="Search" @click="handleQuery">{{ $t('global.search') }}</el-button>
        <el-button icon="Refresh" @click="resetQuery">{{ $t('global.reset') }}</el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
            type="primary"
            plain
            icon="Plus"
            @click="handleAdd"
            v-hasPermi="['system:dept:add']"
        >{{ $t('global.add') }}</el-button>
      </el-col>
      <!-- <el-col :span="1.5">
        <el-button
            type="info"
            plain
            icon="Sort"
            @click="toggleExpandAll"
        >{{ $t('global.collapse') }}</el-button>
      </el-col> -->
      <el-col :span="1.5">
        <el-button
            type="danger"
            plain
            icon="Delete"
            :disabled="multiple"
            @click="handleDelete"
            v-hasPermi="['system:dept:remove']"
        >{{ $t('global.delete') }}</el-button>
      </el-col>
      <!-- <right-toolbar v-model:showSearch="showSearch" @queryTable="getList"></right-toolbar> -->
    </el-row>

    <el-table
        ref="multipleTable"
        v-if="refreshTable"
        v-loading="loading"
        :data="deptList"
        row-key="deptId"
        :default-expand-all="isExpandAll"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column :label="$t('company.id')" prop="deptId"></el-table-column>
      <el-table-column prop="deptName" :label="$t('company.table.name')" v-slot="{ row }" width="200">
        <template v-if="checkTextOverflow(row.deptName)">
          <el-tooltip :content="row.deptName" placement="top">
            <span class="overflow-text">{{ truncateText(row.deptName, 10) }}</span>
          </el-tooltip>
        </template>
        <template v-else>
          <span>{{ row.deptName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="abbreviation" :label="$t('company.table.abbreviation')" v-slot="{ row }">
        <template v-if="checkTextOverflow(row.abbreviation)">
          <el-tooltip :content="row.abbreviation" placement="top">
            <span class="overflow-text">{{ truncateText(row.abbreviation, 10) }}</span>
          </el-tooltip>
        </template>
        <template v-else>
          <span>{{ row.abbreviation }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="nameKana" :label="$t('company.table.jpCompanyName')" v-slot="{ row }">
        <template v-if="checkTextOverflow(row.nameKana)">
          <el-tooltip :content="row.nameKana" placement="top">
            <span class="overflow-text">{{ truncateText(row.nameKana, 10) }}</span>
          </el-tooltip>
        </template>
        <template v-else>
          <span>{{ row.nameKana }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="phoneNo" :label="$t('company.table.telephoneNumber')"></el-table-column>
      <el-table-column prop="type" :label="$t('company.table.companyType')" width="80" align="center">
        <template #default="scope">
          <dict-tag :options="sys_company_type" :value="scope.row.type" />
        </template>
      </el-table-column>
      <el-table-column :label="$t('company.table.createTime')" align="center" prop="createTime" width="160">
        <template #default="scope">
          <span>{{ parseTime(scope.row.createTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('company.table.updateTime')" align="center" width="160">
        <template #default="scope">
          <span>{{ parseTime(scope.row.updateTime) }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="orderNum" :label="$t('global.sort')" width="50"></el-table-column> -->
      <!-- <el-table-column prop="status" :label="$t('global.status')" width="60" align="center">
        <template #default="scope">
          <dict-tag :options="sys_normal_disable" :value="scope.row.status" />
        </template>
      </el-table-column> -->
      <el-table-column :label="$t('global.operation')" align="center" class-name="small-padding fixed-width" width="250" >
        <template #default="scope">
          <el-button link type="primary" icon="Edit" @click="handleUpdate(scope.row)" v-hasPermi="['system:dept:edit']">{{ $t("global.edit") }}</el-button>
          <!-- <el-button link type="primary" icon="Plus" @click="handleAdd(scope.row)" v-hasPermi="['system:dept:add']">{{ $t('global.add') }}</el-button> -->
          <el-button link type="primary" icon="Delete" @click="handleDelete(scope.row)" v-hasPermi="['system:dept:remove']">{{ $t('global.delete') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total > 0"
      :total="total"
      v-model:page="queryParams.pageNum"
      v-model:limit="queryParams.pageSize"
      @pagination="getList"
      />
    <!-- 添加或修改会社对话框 -->
    <el-dialog :title="title" v-model="open" width="600px" append-to-body :close-on-click-modal="false">
      <el-form ref="deptRef" :model="form" :rules="rules" label-width="100px">
        <el-row>
          <!-- <el-col :span="24" v-if="form.parentId !== 0">
            <el-form-item :label="$t('company.parentId')" prop="parentId" >
              <el-tree-select
                  v-model="form.parentId"
                  :data="deptOptions"
                  :props="{ value: 'deptId', label: 'deptName', children: 'children' }"
                  value-key="deptId"
                  :placeholder="$t('global.plsSelect') + $t('company.parentId')"
                  check-strictly
              />
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item :label="$t('company.table.name')" prop="deptName">
              <el-input v-model="form.deptName" :placeholder="'会社名' + $t('global.plsInput')" />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item :label="$t('global.displaySort')" prop="orderNum">
              <el-input-number v-model="form.orderNum" controls-position="right" :min="0" />
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item :label="$t('company.table.abbreviation')" prop="abbreviation">
              <el-input v-model="form.abbreviation" :placeholder="$t('company.table.abbreviation') + $t('global.plsInput')" maxlength="20" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('company.table.jpCompanyName')" prop="nameKana">
              <el-input v-model="form.nameKana" :placeholder="$t('company.table.jpCompanyName') + $t('global.plsInput')" maxlength="20" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('company.table.telephoneNumber')" prop="phoneNo">
              <el-input v-model="form.phoneNo" :placeholder="$t('company.table.telephoneNumber') + $t('global.plsInput')" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('company.table.companyType')" prop="type">
              <keep-result-select
                :placeholder="$t('global.deptStatus')"
                v-model="form.type"
                :list="sys_company_type"
              />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item :label="$t('global.deptStatus')">
              <el-radio-group v-model="form.status">
                <el-radio
                    v-for="dict in sys_normal_disable"
                    :key="dict.value"
                    :label="dict.value"
                >{{ dict.label }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col> -->
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" @click="submitForm">{{ $t('global.confirm') }}</el-button>
          <el-button @click="cancel">{{ $t('global.cancel') }}</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup name="Dept">
import { useI18n } from 'vue-i18n';
import {
  listDept, getDept, delDept, addDept, updateDept, listDeptExcludeChild,
} from '@/api/system/dept';
import { checkTextOverflow, truncateText } from '@/utils/common';
import selectMixin from '@/utils/useSelect.js';

const { proxy } = getCurrentInstance();
const { t } = useI18n();
const { sys_normal_disable } = proxy.useDict('sys_normal_disable');
const { sys_company_type } = proxy.useDict('sys_company_type');

const deptList = ref([]);
const open = ref(false);
const loading = ref(true);
const showSearch = ref(true);
const title = ref('');
const deptOptions = ref([]);
const isExpandAll = ref(true);
const refreshTable = ref(true);
const total = ref(0);
const isSyncingSelection = ref(false);
const ids = ref([]);
const multiple = ref(true);
const multipleTable = ref(null);

const data = reactive({
  form: {},
  queryParams: {
    pageNum: 1,
    pageSize: 50,
    deptName: undefined,
    status: undefined,
  },
  rules: {
    deptName: [
      { validator: proxy.$validateEmpty(`会社名${proxy.$t('global.plsInput')}`, true), required: true, trigger: 'blur' },
    ],
    // parentId: [{ required: true, message: "上级会社不能为空", trigger: "blur" }],
    abbreviation: [
      { validator: proxy.$validateEmpty(), trigger: 'blur' },
    ],
    nameKana: [
      { validator: proxy.$validateEmpty(), trigger: 'blur' },
    ],
    // orderNum: [{ required: true, message: '显示排序不能为空', trigger: 'blur' }],
    // email: [{ type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }],
    phoneNo: [
      { validator: proxy.$validateEmpty(), trigger: 'blur' },
    ],
    type: [{ required: true, message: t('company.table.companyType') + t('global.plsSelect'), trigger: 'change' }],
  },
});

const { queryParams, form, rules } = toRefs(data);

function syncSelection() {
  proxy.$refs.multipleTable.clearSelection();
  deptList.value.forEach((row) => {
    if (ids.value.includes(row.deptId)) {
      proxy.$refs.multipleTable.toggleRowSelection(row, true);
    }
  });
}

/** 查询会社列表 */
function getList() {
  isSyncingSelection.value = true;
  loading.value = true;
  listDept(queryParams.value).then((response) => {
    total.value = response.total;
    deptList.value = proxy.handleTree(response.rows, 'deptId');
    loading.value = false;
    proxy.$nextTick(() => {
      syncSelection();
      isSyncingSelection.value = false; // 重置标志
    });
  });
}
/** 取消按钮 */
function cancel() {
  open.value = false;
  reset();
}
/** 表单重置 */
function reset() {
  form.value = {
    deptId: undefined,
    parentId: undefined,
    deptName: undefined,
    orderNum: 0,
    leader: undefined,
    phone: undefined,
    email: undefined,
    status: '0',
  };
  proxy.resetForm('deptRef');
}
/** 搜索按钮操作 */
function handleQuery() {
  queryParams.value.pageNum = 1;
  getList();
}
/** 重置按钮操作 */
function resetQuery() {
  proxy.resetForm('queryRef');
  handleQuery();
}
/** 新增按钮操作 */
function handleAdd() {
  reset();
  // listDept().then((response) => {
  //   deptOptions.value = proxy.handleTree(response.data, 'deptId');
  // });
  // if (row != undefined) {
  //   form.value.parentId = row.deptId;
  // }
  open.value = true;
  title.value = '会社作成';
}
/** 展开/折叠操作 */
// function toggleExpandAll() {
//   refreshTable.value = false;
//   isExpandAll.value = !isExpandAll.value;
//   nextTick(() => {
//     refreshTable.value = true;
//   });
// }
/** 修改按钮操作 */
function handleUpdate(row) {
  reset();
  // listDeptExcludeChild(row.deptId).then((response) => {
  //   deptOptions.value = proxy.handleTree(response.data, 'deptId');
  // });
  getDept(row.deptId).then((response) => {
    form.value = response.data;
    open.value = true;
    title.value = '会社';
  });
}
/** 提交按钮 */
function submitForm() {
  proxy.$refs.deptRef.validate((valid) => {
    if (valid) {
      if (form.value.deptId != undefined) {
        updateDept(form.value).then((response) => {
          proxy.$modal.msgSuccess(proxy.$t('global.editSuccess'));
          open.value = false;
          getList();
        });
      } else {
        addDept(form.value).then((response) => {
          proxy.$modal.msgSuccess(proxy.$t('global.addSuccess'));
          open.value = false;
          getList();
        });
      }
    }
  });
}
/** 删除按钮操作 */
function handleDelete(row) {
  const deleteIds = row.deptId || ids.value;
  proxy.$modal.confirm(`${proxy.$t('global.confirmDelete')}${deleteIds}?`).then(function () {
    return delDept(deleteIds);
  }).then(() => {
    getList();
    proxy.$modal.msgSuccess(proxy.$t('global.deleteSuccess'));
    ids.value = [];
    multiple.value = true;
  }).catch(() => {});
}
const handleSelectionChange = (selection) => {
  if (isSyncingSelection.value) return; // 在同步过程中，不处理选中状态变更
  const selectedIdsOnCurrentPage = deptList.value.map((item) => item.deptId);
  ids.value = ids.value
    .filter((id) => !selectedIdsOnCurrentPage.includes(id)) // 移除当前页面不再选中的ID
    .concat(selection.map((item) => item.deptId)); // 添加当前页面新选中的ID
  multiple.value = !ids.value.length;
};
getList();
</script>
